import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function LegalLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-24 pb-16 px-4 md:px-6">
        <article className="mx-auto max-w-3xl">
          <h1 className="font-heading text-3xl font-bold text-foreground-950">{title}</h1>
          <div className="mt-6 text-sm leading-7 text-foreground-700 space-y-4">{children}</div>
          <Link to="/" className="inline-block mt-8 text-sm font-semibold text-primary-600">
            返回首页
          </Link>
        </article>
      </main>
      <Footer />
    </div>
  );
}
